import { ref, computed } from "vue";

import store from "../state/store"


export default function useTransactions(props, emit) {


    const transactionStatus = ref("")
    const search = ref("")
    const perPage = ref(10)
    const sortField = ref("updated_at")
    const sortDirection = ref("desc")
    const loading = ref(false)


    const show = computed({
        get: () => props.modelValue,
        set: (value) => emit("update:modelValue", value),
    })

    const getTransactions = (url = null) => {
        store.dispatch("getTransactions", {
            url,
            search: search.value,
            status: transactionStatus.value,
            per_page: perPage.value,
            sort_field: sortField.value,
            sort_direction: sortDirection.value,
        })
    }


    return {
        show,
        transactionStatus,
        search,
        perPage,
        loading,
        getTransactions
    }
}